"use strict";
exports.__esModule = true;
exports.Integration = exports.MarketplaceAppPricingModel = exports.MarketplaceAppStatus = exports.MarketplaceAppType = exports.MarketplaceAppDocument = void 0;
var MarketplaceAppDocument = /** @class */ (function () {
    function MarketplaceAppDocument(id, slug, name, status, pricing, company_name, icon, description, tagline, redirect_url, og_image_url, install_url, installation_instructions, contact_details, rating, reviews, install_count, screenshots, youtube_video_link, categories, website_app_path, created_on, updated_on, is_installed, allow_multiple_accounts, recommended, scope_ids) {
        this.id = id;
        this.slug = slug;
        this.name = name;
        this.status = status;
        this.pricing = pricing;
        this.company_name = company_name;
        this.icon = icon;
        this.description = description;
        this.tagline = tagline;
        this.redirect_url = redirect_url;
        this.og_image_url = og_image_url;
        this.install_url = install_url;
        this.installation_instructions = installation_instructions;
        this.contact_details = contact_details;
        this.rating = rating;
        this.reviews = reviews;
        this.install_count = install_count;
        this.screenshots = screenshots;
        this.youtube_video_link = youtube_video_link;
        this.categories = categories;
        this.website_app_path = website_app_path;
        this.created_on = created_on;
        this.updated_on = updated_on;
        this.is_installed = is_installed;
        this.allow_multiple_accounts = allow_multiple_accounts;
        this.recommended = recommended;
        this.scope_ids = scope_ids;
    }
    MarketplaceAppDocument.fromJSON = function (json) {
        var integration = new MarketplaceAppDocument(0, '', '', MarketplaceAppStatus.ACTIVE, MarketplaceAppPricingModel.Free, '', '', '', '', null, '', '', '', {}, { count: 0, average: 0 }, 0, 0, [], '', [], '', 0, 0, false, false, [], []);
        if (json) {
            integration.id = json.id ? json.id : 0;
            integration.slug = json.slug ? json.slug : '';
            integration.name = json.name ? json.name : '';
            integration.status = json.status ? json.status : MarketplaceAppStatus.ACTIVE;
            integration.pricing = json.pricing ? json.pricing : MarketplaceAppPricingModel.Free;
            integration.company_name = json.company_name ? json.company_name : '';
            integration.icon = json.icon ? json.icon : '';
            integration.description = json.description ? json.description : '';
            integration.tagline = json.tagline ? json.tagline : '';
            integration.redirect_url = json.redirect_url !== undefined ? json.redirect_url : null;
            integration.og_image_url = json.og_image_url ? json.og_image_url : '';
            integration.install_url = json.install_url ? json.install_url : '';
            integration.installation_instructions = json.installation_instructions ? json.installation_instructions : '';
            // Handle contact_details object
            integration.contact_details = json.contact_details ? {
                support_email: json.contact_details.support_email || undefined,
                support_url: json.contact_details.support_url || undefined,
                pricing_page_url: json.contact_details.pricing_page_url || undefined,
                privacy_policy: json.contact_details.privacy_policy || undefined,
                terms_of_service: json.contact_details.terms_of_service || undefined,
                website_url: json.contact_details.website_url || undefined,
                documentation_url: json.contact_details.documentation_url || undefined,
                issue_tracker_url: json.contact_details.issue_tracker_url || undefined,
                dashboard_url: json.contact_details.dashboard_url || undefined,
                setup_guide: json.contact_details.setup_guide || undefined
            } : {};
            // Handle rating object
            integration.rating = json.rating ? {
                count: json.rating.count || 0,
                average: json.rating.average || 0
            } : { count: 0, average: 0 };
            integration.reviews = json.reviews ? json.reviews : 0;
            integration.install_count = json.install_count ? json.install_count : 0;
            integration.screenshots = json.screenshots && Array.isArray(json.screenshots) ? json.screenshots : [];
            integration.youtube_video_link = json.youtube_video_link ? json.youtube_video_link : '';
            integration.categories = json.categories && Array.isArray(json.categories) ? json.categories : [];
            integration.website_app_path = json.website_app_path ? json.website_app_path : '';
            integration.created_on = json.created_on ? json.created_on : 0;
            integration.updated_on = json.updated_on ? json.updated_on : 0;
            integration.is_installed = json.is_installed !== undefined ? json.is_installed : false;
            integration.allow_multiple_accounts = json.allow_multiple_accounts !== undefined ? json.allow_multiple_accounts : false;
            integration.recommended = json.recommended && Array.isArray(json.recommended) ? json.recommended : [];
            integration.scope_ids = json.scope_ids && Array.isArray(json.scope_ids) ? json.scope_ids : [];
        }
        return integration;
    };
    // Getter to get full scope details from IDs
    MarketplaceAppDocument.prototype.getSelectedScopes = function () {
        return this.scope_ids
            .map(function (id) { return AVAILABLE_SCOPES.find(function (scope) { return scope.id === id; }); })
            .filter(function (scope) { return scope !== undefined; });
    };
    // Helper to check if a specific scope is selected
    MarketplaceAppDocument.prototype.hasScope = function (scopeId) {
        return this.scope_ids.includes(scopeId);
    };
    // Helper to add a scope
    MarketplaceAppDocument.prototype.addScope = function (scopeId) {
        if (!this.scope_ids.includes(scopeId)) {
            this.scope_ids.push(scopeId);
        }
    };
    // Helper to remove a scope
    MarketplaceAppDocument.prototype.removeScope = function (scopeId) {
        this.scope_ids = this.scope_ids.filter(function (id) { return id !== scopeId; });
    };
    return MarketplaceAppDocument;
}());
exports.MarketplaceAppDocument = MarketplaceAppDocument;
var MarketplaceAppType;
(function (MarketplaceAppType) {
    MarketplaceAppType["COMMUNICATION"] = "communication";
    MarketplaceAppType["MARKETING"] = "marketing";
    MarketplaceAppType["SALES"] = "sales";
    MarketplaceAppType["AUTOMATION"] = "automation";
    MarketplaceAppType["ANALYTICS"] = "analytics";
    MarketplaceAppType["DOCUMENT"] = "document";
    MarketplaceAppType["PAYMENT"] = "payment";
    MarketplaceAppType["SUPPORT"] = "support";
    MarketplaceAppType["PRODUCTIVITY"] = "productivity";
    MarketplaceAppType["DATAMANAGEMENT"] = "data_management";
    MarketplaceAppType["ACCOUNTING"] = "accounting";
    MarketplaceAppType["ERP"] = "erp";
    MarketplaceAppType["CALENDAR"] = "calendar";
    MarketplaceAppType["ECOMMERCE"] = "ecommerce";
    MarketplaceAppType["SOCIALMEDIA"] = "social_media";
    MarketplaceAppType["HR"] = "hr";
    MarketplaceAppType["COLLABORATION"] = "collaboration";
    MarketplaceAppType["PROJECTMANAGEMENT"] = "project_management";
    MarketplaceAppType["INVENTORY"] = "inventory";
    MarketplaceAppType["LEARNING"] = "learning";
    MarketplaceAppType["LEGAL"] = "legal";
    MarketplaceAppType["SECURITY"] = "security";
    MarketplaceAppType["TELEPHONY"] = "telephony";
    MarketplaceAppType["REAL_ESTATE"] = "real_estate";
    MarketplaceAppType["AI"] = "ai";
    MarketplaceAppType["SURVEY"] = "survey";
    MarketplaceAppType["LOCATION"] = "location";
    MarketplaceAppType["MOBILE"] = "mobile";
    MarketplaceAppType["UNOFFICIAL"] = "unofficial";
    MarketplaceAppType["FEATURED"] = "featured";
})(MarketplaceAppType = exports.MarketplaceAppType || (exports.MarketplaceAppType = {}));
var MarketplaceAppStatus;
(function (MarketplaceAppStatus) {
    MarketplaceAppStatus["ACTIVE"] = "active";
    MarketplaceAppStatus["INACTIVE"] = "inactive";
    MarketplaceAppStatus["PENDING"] = "pending";
    MarketplaceAppStatus["ERROR"] = "error";
    MarketplaceAppStatus["SUSPENDED"] = "suspended";
})(MarketplaceAppStatus = exports.MarketplaceAppStatus || (exports.MarketplaceAppStatus = {}));
var MarketplaceAppPricingModel;
(function (MarketplaceAppPricingModel) {
    MarketplaceAppPricingModel["Free"] = "free";
    MarketplaceAppPricingModel["Freemium"] = "freemium";
    MarketplaceAppPricingModel["Paid"] = "paid";
})(MarketplaceAppPricingModel = exports.MarketplaceAppPricingModel || (exports.MarketplaceAppPricingModel = {}));
var AVAILABLE_SCOPES = [
    {
        "id": 1,
        "name": "base",
        "title": "Access to Basic Information",
        "description": "Read settings of the authorized user and currencies in an account. This is the default permission that is always enabled for all apps."
    },
    {
        "id": 2,
        "name": "contacts:read",
        "title": "Contacts: Read Only",
        "description": "Read all contact data, including custom fields, filters, and associated metadata. Does not include write access."
    },
    {
        "id": 3,
        "name": "contacts:write",
        "title": "Contacts: Full Access",
        "description": "Create, update, and delete contacts, including managing custom fields and filters."
    },
    {
        "id": 4,
        "name": "companies:read",
        "title": "Companies: Read Only",
        "description": "Read all company data, including custom fields, filters, and associated metadata. Does not include write access."
    },
    {
        "id": 5,
        "name": "companies:write",
        "title": "Companies: Full Access",
        "description": "Create, update, and delete companies, including managing custom fields and filters."
    },
    {
        "id": 6,
        "name": "deals:read",
        "title": "Deals: Read Only",
        "description": "Read most data about deals and related entities - deal fields, products, followers, participants; all notes, files, filters, pipelines, stages, and statistics. Does not include access to activities (except last and next activity related to a deal)."
    },
    {
        "id": 7,
        "name": "deals:write",
        "title": "Deals: Full Access",
        "description": "Create, read, update, and delete deals, including participants and followers; manage all files, notes, and filters. Also includes read access to deal fields, pipelines, stages, and statistics. Does not include access to activities (except last and next activity related to a deal)."
    },
    {
        "id": 8,
        "name": "leads:read",
        "title": "Leads: Read Only",
        "description": "Read all lead data, including custom fields, filters, and associated metadata. Does not include write access."
    },
    {
        "id": 9,
        "name": "leads:write",
        "title": "Leads: Full Access",
        "description": "Create, update, and delete leads, including managing custom fields and filters."
    },
    {
        "id": 10,
        "name": "activities:read",
        "title": "Activities: Read Only",
        "description": "Read all activity data, including calls, emails, meetings, and tasks associated with contacts, companies, deals, and leads."
    },
    {
        "id": 11,
        "name": "activities:write",
        "title": "Activities: Full Access",
        "description": "Create, update, and delete activities such as calls, emails, meetings, and tasks associated with contacts, companies, deals, and leads."
    },
    {
        "id": 12,
        "name": "pipelines:read",
        "title": "Pipelines: Read Only",
        "description": "Read pipeline configurations, including stages and associated metadata. Does not include write access."
    },
    {
        "id": 13,
        "name": "pipelines:write",
        "title": "Pipelines: Full Access",
        "description": "Create, update, and delete pipeline configurations, including stages and associated metadata."
    },
    {
        "id": 14,
        "name": "users:read",
        "title": "Users: Read Only",
        "description": "Read user profiles and roles within the account. Does not include write access."
    },
    {
        "id": 15,
        "name": "settings:read",
        "title": "Settings: Read Only",
        "description": "Read account settings, including preferences and configurations. Does not include write access."
    },
    {
        "id": 16,
        "name": "webhooks:read",
        "title": "Webhooks: Read Only",
        "description": "Read webhook configurations and statuses. Does not include write access."
    },
    {
        "id": 17,
        "name": "webhooks:write",
        "title": "Webhooks: Full Access",
        "description": "Create, update, and delete webhook configurations."
    },
    {
        "id": 18,
        "name": "admin",
        "title": "Admin Access",
        "description": "Access to administrative functionalities, including managing users and account-wide settings."
    },
    {
        "id": 19,
        "name": "full_access",
        "title": "Full Access",
        "description": "Full access to all resources and functionalities within the account."
    }
];
exports.Integration = [
    new MarketplaceAppDocument(101, 'whastapp-web', 'Whatsapp web', MarketplaceAppStatus.ACTIVE, MarketplaceAppPricingModel.Free, 'Ditto CRM', 'https://static-00.iconduck.com/assets.00/whatsapp-icon-1024x1024-cilsjgvb.png', " Connect your CRM with WhatsApp Web to streamline customer communication and boost your sales productivity.\n        \n\n### Key Features\n\n- **Send Messages**: Send personalized messages directly from your CRM to WhatsApp contacts\n- **Receive Messages**: Automatically sync incoming WhatsApp messages to your CRM contact records\n- **Contact Sync**: Seamlessly integrate WhatsApp contacts with your existing CRM database\n- **Message History**: Keep track of all WhatsApp conversations within your CRM timeline\n- **Quick Actions**: Send follow-up messages, appointment reminders, and marketing updates\n\n### Benefits\n\n- Reduce response time to customer inquiries\n- Centralize all customer communications in one place\n- Improve customer engagement with instant messaging\n- Track conversation history for better customer insights\n- Boost sales conversion with timely follow-ups\n\nPerfect for sales teams, customer support, and marketing professionals who want to leverage WhatsApp's popularity for better customer relationships.", 'Connect WhatsApp Web with your CRM for seamless customer messaging', null, '', 'https://app.yourcrm.com/integrations/whatsapp/install', "1. Click the \"Install\" button above\n2. You'll be redirected to your CRM dashboard\n3. Navigate to **Settings > Integrations > WhatsApp Web**\n4. Click \"Enable Integration\"", {
        support_email: undefined,
        support_url: 'https://www.whatsapp.com/contact',
        pricing_page_url: undefined,
        privacy_policy: 'https://www.whatsapp.com/legal/privacy-policy',
        terms_of_service: 'https://www.whatsapp.com/legal/terms-of-service',
        website_url: 'http://web.whatsapp.com/',
        documentation_url: undefined,
        issue_tracker_url: undefined,
        dashboard_url: undefined,
        setup_guide: undefined
    }, {
        count: 0,
        average: 0
    }, 0, 0, [
        'https://pipedrive-marketplace-manager-live.s3.amazonaws.com/10f6b602cda330ef/screenshot/82285715-8d3f-4ace-afb8-2b6cb676a195/1280x800.jpeg',
        'https://pipedrive-marketplace-manager-live.s3.amazonaws.com/10f6b602cda330ef/screenshot/82285715-8d3f-4ace-afb8-2b6cb676a195/1280x800.jpeg',
    ], 'https://www.youtube.com/watch?v=GsZOqmLaddo', [MarketplaceAppType.COMMUNICATION, MarketplaceAppType.SUPPORT, MarketplaceAppType.FEATURED, MarketplaceAppType.UNOFFICIAL], 'https://telesaleslinkcrm.com/marketplace/app/whatsapp-web/1', 1748754911299, 1748754911299, false, true, [], [1, 2, 11]),
];
